import request from "../utils/request";


export const getRebates = '/rebate';

export function AddRebate(values: any) {
    return request.post('/rebate', values);
}

export function getRebate(id: number) {
    return request.get('/rebate/detail', {params: {id}});
}

export function approveRebate(id: number) {
    return request.put('/rebate/audit', {}, {params: {id}});
}

export function closeRebate(id: number) {
    return request.put('/rebate/close', {}, {params: {id}});
}

export function updateRebate(params: any) {
    return request.put('/rebate', params);
}

export function hasRemain(salesOrderId: number) {
    return request.get('/rebate/hasRemain', {params: {salesOrderId}});
}

export const getRebateSummary = '/rebate/summary';
export const getTransactions = '/rebate/transactions';


export function importRebateOrders(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/rebate/import',
        method: 'post',
        data: formData
    })
}

export function importRebateOrderProducts(orderId: string, file: File) {
    const formData = new FormData()
    formData.append('orderId', orderId)
    formData.append('file', file)
    return request.request({
        url: '/rebate/detail/import',
        method: 'post',
        data: formData
    })
}
